var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAmexi = function SvgAmexi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#296db6",
    d: "M8.143 24.514h2.743l-1.37-3.43-1.372 3.43zM46.372 18h-7.03l-1.714 1.886L36.086 18H21.172l-1.37 3.086L18.43 18h-6v1.37L11.743 18H6.6L1.63 30h6l.686-1.886h1.714L10.715 30H17.4v-1.37l.514 1.37h3.43l.514-1.543V30h13.714l1.714-1.886L38.83 30h7.03l-4.46-6 4.97-6zM25.8 28.286h-2.057V21.6l-2.914 6.686h-1.714L16.2 21.6v6.686h-3.942l-.686-1.886H7.458l-.686 1.886h-2.23l3.6-8.57h2.914l3.257 8.057v-8.058h3.257l2.57 5.83 2.4-5.83h3.26v8.572zm16.8 0h-2.57l-2.23-2.914-2.57 2.914h-7.714v-8.572H35.4l2.4 2.743 2.57-2.743h2.4L39 24l3.6 4.286zM29.4 21.43v1.543h4.286v1.714H29.4V26.4h4.8l2.23-2.57-2.057-2.4H29.4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAmexi);
export default ForwardRef;